import React, { useEffect, useState } from "react"
import { Button, Form, InputGroup, Modal, OverlayTrigger, Table, Toast, ToastContainer, Tooltip } from "react-bootstrap";
import styles from './style.module.css';
import { HttpNoData } from "../../../Core";
import { HiMiniReceiptPercent } from "react-icons/hi2";
import { FaRubleSign } from "react-icons/fa";
import { IoResize } from "react-icons/io5";
import { RxHeight } from "react-icons/rx";
import { AiOutlineNumber } from "react-icons/ai";

export default function Product({ product, jwt, isUse, onSum, onWeight, onUpdate, additionCoefficient }) {

    const [currentAdditions, setCurrentAddition] = useState(product.additions ?? []);
    const [currentRangeSizes, setCurrentRangeSizes] = useState([]);
    const [currentRangeThickness, setCurrentRangeThickness] = useState([]);
    const [currentCountPrices, setCurrentCountPrices] = useState([]);

    const [selfCount, setSelfCount] = useState(product.selfCount ?? 1);
    const [priceSelf, setPriceSelf] = useState(product.priceSelf ?? 0);

    const [errorToast, setErrorToast] = useState();

    const [thickness, setThickness] = useState(product.thicknessUser ?? product.standardThickness);
    const [size, setSize] = useState(product.sizeUser ?? product.standardSize);
    const [weight, setWeight] = useState(0);

    const [exactWeight, setExactWeight] = useState(null);
    const [selectedSizePrice, setSelectedSizePrice] = useState(0);
    const [selectedSizeRecord, setSelectedSizeRecord] = useState(null);

    const [discountsPercent, setDiscountsPercent] = useState(product.discountsPercent ?? []);
    const [discountsValue, setDiscountsValue] = useState(product.discountsValue ?? []);

    const [percentId, setPercentId] = useState(product.discountsPercent && product.discountsPercent.length > 0 ? product.discountsPercent[product.discountsPercent.length - 1].id : 1);
    const [valueId, setValueId] = useState(product.discountsValue && product.discountsValue.length > 0 ? product.discountsValue[product.discountsValue.length - 1].id : 1);

    const [sumSize, setSumSize] = useState(product.sumSize ?? 0);
    const [nominalPrice, setNominalPrice] = useState(product.nominalPrice ?? 0);
    const [sumAddition, setSumAddition] = useState(product.sumAddition ?? 0);
    const [priceEnd, setPriceEnd] = useState(product.priceEnd ?? 0);
    const [priceSumCount, setPriceSumCount] = useState(product.priceSumCount ?? 0);

    const [isInvalidSize, setIsInvalidSize] = useState(false);
    const [isInvalidCount, setIsInvalidCount] = useState(false);

    const [showQuantityModal, setShowQuantityModal] = useState(false);
    const [pendingAddition, setPendingAddition] = useState(null);
    const [quantityInput, setQuantityInput] = useState(1);

    useEffect(() => {

        async function didMount() {
            const sizes = await HttpNoData(`/api/v1/calculateOrderCost/productRangeSizes/${product.id}`, 'GET', jwt);

            if (sizes.statusSuccessful)
                setCurrentRangeSizes(sizes.data?.sort((a, b) => a.size - b.size) ?? []);

            const thicknessResponse = await HttpNoData(`/api/v1/calculateOrderCost/productRangeThickness/${product.id}`, 'GET', jwt);

            if (thicknessResponse.statusSuccessful)
                setCurrentRangeThickness(thicknessResponse.data?.sort((a, b) => a.thickness - b.thickness) ?? []);

            const additions = await HttpNoData(`/api/v1/calculateOrderCost/products/additions/${product.id}`, 'GET', jwt);

            if (additions.statusSuccessful && additions.data)
                setCurrentAddition([...currentAdditions, ...additions.data?.filter(f => currentAdditions.findIndex(find => find.id == f.id) == -1)]);

            const countPrices = await HttpNoData(`/api/v1/calculateOrderCost/products/countPrices/${product.id}`, 'GET', jwt);

            if (additions.statusSuccessful)
                setCurrentCountPrices(countPrices.data?.sort((a, b) => a.count - b.count) ?? []);
        }

        didMount();

    }, []);

    const renderDiscountTooltip = (props) => {
        const validDiscounts = currentCountPrices.filter(d => d.discount !== 0);
        if (validDiscounts.length === 0) {
            return <Tooltip {...props} style={{ display: 'none' }}></Tooltip>;
        }
        return (
            <Tooltip id="discount-tooltip" {...props}>
                <div style={{ padding: '5px' }}>
                    <strong>Скидки от количества:</strong>
                    {validDiscounts
                        .sort((a, b) => a.count - b.count)
                        .map(discount => (
                            <div key={discount.id}>
                                от {discount.count} шт. - {discount.discount > 0
                                    ? `${(+nominalPrice + +sumAddition) * (1 - discount.discount / 100)}₽`
                                    : `${+nominalPrice + +sumAddition - Math.abs(discount.discount)}₽`}
                            </div>
                        ))}
                </div>
            </Tooltip>
        );
    };

    // Цена за размер
    useEffect(() => {
        if (product.useExactWeights && selectedSizeRecord) {
            setSumSize(Math.ceil(selectedSizeRecord.price));
            return;
        }

        setIsInvalidSize(false);
        const numericSize = Number(size);

        if (product.minSize === 0 && product.maxSize === 0) {
            if (isNaN(numericSize) || numericSize == -1) {
                setIsInvalidSize(true);
                onSum(product, 0);
                return;
            }
        } else {
            if (isNaN(numericSize)) {
                setIsInvalidSize(true);
                onSum(product, 0);
                return;
            }

            if (numericSize < product.minSize || numericSize > product.maxSize) {
                setErrorToast({
                    key: 'outRange',
                    message: `К сожалению вы вышли за границы продукции. \n От ${product.minSize}мм до ${product.maxSize}мм`,
                    variant: 'danger'
                });
                setIsInvalidSize(true);
                return;
            }
        }

        if (errorToast && errorToast.key == 'outRange') {
            setErrorToast();
        }

        if (currentRangeSizes.length <= 1) {
            setSumSize(Math.ceil(currentRangeSizes[0]?.price ?? 0));
            return;
        }

        for (let i = 0; i < currentRangeSizes.length; i++) {
            const element = currentRangeSizes[i];

            if (element.size < numericSize && currentRangeSizes.length - (i + 1) > 0)
                continue;

            if (element.size == numericSize) {
                setSumSize(Math.ceil(element.price));
                break;
            }

            let minPrice = i == 0 ? 0 : currentRangeSizes[i - 1].price;
            let maxPrice = element.price;
            let minSize = i == 0 ? 0 : currentRangeSizes[i - 1].size;
            let maxSize = element.size;

            setSumSize(Math.ceil((maxPrice - minPrice) / (maxSize - minSize) * (numericSize - minSize) + minPrice));
            break;
        }

    }, [size, currentRangeSizes, product.useExactWeights, selectedSizeRecord]);

    // Номинал с учётом толщины
    useEffect(() => {

        if (product.standardThickness == thickness) {
            const nominalPrice = +sumSize;
            setNominalPrice(Math.ceil(nominalPrice));
            return;
        }

        let upperPriceOnThickness = 0;
        for (let i = 0; i < currentRangeThickness.length; i++) {
            const element = currentRangeThickness[i];

            if (element.thickness < thickness && currentRangeThickness.length - (i + 1) > 0)
                continue;

            upperPriceOnThickness = element.percent / 100;
            break;
        }

        const nominalPrice = +(+sumSize + (+sumSize * upperPriceOnThickness));
        setNominalPrice(Math.ceil(nominalPrice));
    }, [thickness, sumSize]);

    useEffect(() => {
        onUpdate({
            ...product,
            hasErrors: ((product.minSize !== 0 && product.maxSize !== 0 && (size < product.minSize || size > product.maxSize)) || !Number(size) || isInvalidCount),
            additions: currentAdditions.filter(f => f.isUse),
            isUse: isUse,
            thicknessUser: thickness,
            sizeUser: size,
            discountsPercent: discountsPercent,
            discountsValue: discountsValue,
            sumSize: sumSize,
            sumAddition: sumAddition,
            nominalPrice: nominalPrice,
            selfCount: selfCount,
            priceSelf: priceSelf,
            priceSumCount: priceSumCount,
            priceEnd: priceEnd,
            quantity: selfCount
        });
    }, [thickness, size, priceSumCount, discountsPercent, discountsValue, sumSize, sumAddition, nominalPrice, selfCount, priceEnd, currentAdditions, isUse]);

    // Вес
    useEffect(() => {
        let result;
        if (product.useExactWeights && exactWeight) {
            result = exactWeight * selfCount;
        } else {
            result = ((size * size) / (product.standardSize * product.standardSize) *
                (thickness / product.standardThickness) *
                product.standardWeight) * selfCount;
        }
        setWeight(result);
        onWeight(product, result);
    }, [size, thickness, selfCount, exactWeight, product.useExactWeights, product.standardSize, product.standardThickness, product.standardWeight]);

    // Финальная цена
    useEffect(() => {

        const additionPrice = +nominalPrice + +sumAddition;

        let price = additionPrice;

        if (discountsValue.length > 0)
            price += discountsValue.reduce((a, b) => a + b.value, 0);

        if (discountsPercent.length > 0)
            price += discountsPercent.reduce((a, b) => (b.percent / 100) + a, 0) * additionPrice;

        setPriceEnd(Math.ceil(price));
    }, [discountsPercent, discountsValue, nominalPrice, sumAddition]);

    // Скидки от количества
    useEffect(() => {

        let percentDiscounts = currentCountPrices.filter(f => f.discount > 0).sort((a, b) => a.count - b.count);
        let rublesDiscounts = currentCountPrices.filter(f => f.discount < 0).sort((a, b) => a.count - b.count);
        let discount = 0;
        let rublesCount = 0;

        for (let i = 0; i < rublesDiscounts.length; i++) {
            const element = rublesDiscounts[i];
            if (element.count > selfCount)
                continue;

            discount = element.discount;
            rublesCount = +element.count;
        }
        let percentDiscount = 0;
        let percentCount = 0;
        for (let i = 0; i < percentDiscounts.length; i++) {
            const element = percentDiscounts[i];
            if (element.discount > 0) {
                if (element.count > selfCount)
                    continue;

                percentDiscount = +element.discount;
                percentCount = +element.count;
            }
        }
        const priceWithPercentDiscount = (priceEnd - priceEnd * percentDiscount / 100) * (1 + additionCoefficient);
        const priceWithRublesDiscount = (priceEnd - (-discount)) * (1 + additionCoefficient);
        let priceSelfCalc = 0;
        if (rublesCount == percentCount)
            priceSelfCalc = Math.min(priceWithPercentDiscount, priceWithRublesDiscount);
        else if (rublesCount > percentCount)
            priceSelfCalc = priceWithRublesDiscount;
        else
            priceSelfCalc = priceWithPercentDiscount;
        const ceilPrice = Math.ceil(priceSelfCalc);
        setPriceSelf(ceilPrice);
        setPriceSumCount(ceilPrice * selfCount);
        onSum(product, ceilPrice * selfCount);

    }, [priceEnd, selfCount, additionCoefficient, currentCountPrices]);

    const handleSizeSelect = (e) => {
        const selectedVal = e.target.value;
        setSize(selectedVal);
        const selected = currentRangeSizes.find(s => s.size == selectedVal);
        if (selected) {
            setSelectedSizeRecord(selected);
            setSelectedSizePrice(selected.price);
            setExactWeight(selected.weight);
        }
    };

    return <div className={styles.productItem}>
        <Table bordered hover striped size="sm" style={{ margin: 0, padding: 0 }}>
            <tbody>
                <tr>
                    {size != -1 && thickness != -1 ?
                        <th style={{ width: 200, padding: 0 }}>
                            <InputGroup style={{ maxWidth: 280, flexWrap: 'nowrap' }}>
                                <OverlayTrigger overlay={<Tooltip id={`product-addition-label-1`}>Размер</Tooltip>}>
                                    <InputGroup.Text>
                                        <IoResize />
                                    </InputGroup.Text>
                                </OverlayTrigger>

                                {product.useExactWeights ? (
                                    <Form.Select
                                        disabled={!isUse}
                                        value={size}
                                        onChange={handleSizeSelect}
                                        style={{
                                            ...(isInvalidSize || size < 0) ? {
                                                borderColor: 'red',
                                                boxShadow: '0 0 0 0.2rem rgba(255, 0, 0, 0.25)'
                                            } : {},
                                            width: '150px'
                                        }}
                                    >
                                        {currentRangeSizes.map(si => (
                                            <option key={si.id} value={si.size}>
                                                {si.size} мм
                                            </option>
                                        ))}
                                    </Form.Select>
                                ) : product.minSize === 0 && product.maxSize === 0 ? (
                                    <Form.Select
                                        disabled={!isUse}
                                        value={size}
                                        onChange={e => setSize(Number(e.target.value))}
                                        style={{
                                            ...(isInvalidSize || size < 0 || size != Math.ceil(size)) ? {
                                                borderColor: 'red',
                                                boxShadow: '0 0 0 0.2rem rgba(255, 0, 0, 0.25)'
                                            } : {},
                                            width: '150px'
                                        }}
                                    >
                                        {currentRangeSizes.map(si => (
                                            <option key={si.id} value={si.size}>
                                                {si.size}
                                            </option>
                                        ))}
                                    </Form.Select>
                                ) : (
                                    <>
                                        <Form.Control
                                            disabled={!isUse}
                                            value={size}
                                            onChange={e => setSize(e.target.value)}
                                            type="number"
                                            name="size-select"
                                            placeholder=""
                                            list={`datalist-sizes-product-${product.id}`}
                                            style={{
                                                ...(isInvalidSize || size < 0 || size != Math.ceil(size)) ? {
                                                    borderColor: 'red',
                                                    boxShadow: '0 0 0 0.2rem rgba(255, 0, 0, 0.25)'
                                                } : {},
                                                width: '150px'
                                            }}
                                        />
                                        <datalist id={`datalist-sizes-product-${product.id}`}>
                                            {currentRangeSizes.map(si => <option key={si.id} value={si.size} />)}
                                        </datalist>
                                    </>
                                )}

                                <OverlayTrigger overlay={<Tooltip id={`product-addition-label-2`}>Толщина</Tooltip>}>
                                    <InputGroup.Text>
                                        <RxHeight />
                                    </InputGroup.Text>
                                </OverlayTrigger>

                                <Form.Select
                                    disabled={!isUse}
                                    value={thickness}
                                    placeholder=""
                                    onChange={e => setThickness(e.target.value)}
                                    style={{ width: '100px' }}
                                >
                                    <option value={product.standardThickness}>{product.standardThickness}</option>
                                    {currentRangeThickness.map(item => (
                                        <option key={item.id} value={item.thickness}>{item.thickness}</option>
                                    ))}
                                </Form.Select>
                            </InputGroup>
                        </th> : null
                    }
                    <th style={{ padding: 0 }}>
                        <div className={styles.additionBodyProduct}>
                            {
                                currentAdditions && currentAdditions.length > 0 ?
                                    currentAdditions.map(o => <Form.Group className={styles.additionItem} key={o.id}>
                                        <OverlayTrigger overlay={<Tooltip id={`product-addition-tooltip-${o.id}`}>{o.description}</Tooltip>}>
                                            <Form.Check
                                                disabled={!isUse}
                                                type="switch"
                                                id={`product-${product.id}-addition-${o.id}`}
                                                style={{ marginLeft: 8, marginBottom: -6 }}
                                                label={<span id={`product-${product.id}-addition-${o.id}`}>
                                                    {o.hasQuantity && o.isUse
                                                        ? `${o.name} (${o.quantity || 1} × ${o.price}₽)`
                                                        : `${o.name} (${o.price}₽)`}
                                                </span>}
                                                checked={o.isUse}
                                                onChange={e => {
                                                    if (e.target.checked && o.hasQuantity) {
                                                        setPendingAddition(o);
                                                        setQuantityInput(o.quantity || 1);
                                                        setShowQuantityModal(true);
                                                    } else {
                                                        const updatedAdditions = currentAdditions.map(addition =>
                                                            addition.id === o.id ? { ...addition, isUse: e.target.checked } : addition
                                                        );
                                                        setCurrentAddition(updatedAdditions);
                                                        setSumAddition(e.target.checked
                                                            ? sumAddition + o.price
                                                            : sumAddition - (o.quantity || 1) * o.price
                                                        );
                                                    }
                                                }} />
                                        </OverlayTrigger>

                                    </Form.Group>)
                                    : ''
                            }
                        </div>
                    </th>
                    <th style={{ width: 120, padding: 0 }}>
                        <OverlayTrigger
                            placement="top"
                            delay={{ show: 250, hide: 400 }}
                            overlay={renderDiscountTooltip}
                        >
                            <InputGroup style={{ maxWidth: 120, flexWrap: 'nowrap' }}>
                                <OverlayTrigger overlay={<Tooltip id={`product-addition-label-2`}>Кол-во</Tooltip>}>
                                    <InputGroup.Text>
                                        <AiOutlineNumber />
                                    </InputGroup.Text>
                                </OverlayTrigger>

                                <Form.Control
                                    disabled={!isUse}
                                    value={selfCount}
                                    placeholder=""
                                    style={(isInvalidCount || selfCount < 0 || selfCount != Math.ceil(selfCount)) ? { borderColor: 'red', boxShadow: '0 0 0 0.2rem rgba(255, 0, 0, 0.25)' } : {}}
                                    onChange={e => {
                                        setIsInvalidCount(false);
                                        const value = e.target.value;

                                        if (!Number(value)) {
                                            setIsInvalidCount(true);
                                            return;
                                        }
                                        setSelfCount(value);

                                        if (value <= 0) {
                                            setIsInvalidCount(true);
                                            setErrorToast({ key: 'minZeroCount', message: `К сожалению кол-во продукции не может быть менее 1`, variant: 'danger' })
                                        }

                                        else if (errorToast?.key == 'minZeroCount')
                                            setErrorToast();

                                        if (value % 1 > 0) {
                                            setIsInvalidCount(true);
                                            setErrorToast({ key: 'numberPoint', message: `К сожалению кол-во продукции не может быть дробным`, variant: 'danger' })
                                        }
                                        else if (errorToast?.key == 'numberPoint')
                                            setErrorToast();
                                    }}
                                />
                            </InputGroup>
                        </OverlayTrigger>
                    </th>
                    <th style={{ width: 90, padding: 0 }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <HiMiniReceiptPercent onClick={() => {
                                const value = prompt('Скидка в процентах (Без знака %)', 10)
                                setDiscountsPercent([...discountsPercent, { id: percentId, percent: +value * -1 }]);
                                setPercentId(percentId + 1);
                            }} style={{ width: 18, height: 18, color: 'green' }} />
                            <FaRubleSign onClick={() => {
                                const value = prompt('Скидка в рублях', 10)
                                setDiscountsValue([...discountsValue, { id: valueId, value: +value * -1 }]);
                                setValueId(valueId + 1);
                            }} style={{ width: 18, height: 18, color: 'green' }} />
                        </div>
                        {
                            discountsPercent.map(p => <div key={p.id} className={styles.productPriceItem}>
                                <span className={styles.price_name} onClick={() => setDiscountsPercent([...discountsPercent.filter(f => f.id != p.id)])}>В %</span>
                                <span className={styles.price_separator} />
                                <span className={styles.price_value}>{p.percent}%</span>
                            </div>)
                        }

                        {
                            discountsValue.map(p => <div key={p.id} className={styles.productPriceItem}>
                                <span className={styles.price_name} onClick={() => setDiscountsValue([...discountsValue.filter(f => f.id != p.id)])}>В ₽</span>
                                <span className={styles.price_separator} />
                                <span className={styles.price_value}>{p.value}₽</span>
                            </div>)
                        }
                    </th>
                    <th style={{ width: 120, padding: 0 }}>
                        <div className={styles.productPriceItem}>
                            <span className={styles.price_name}>Номинал</span>
                            <span className={styles.price_separator} />
                            <span className={styles.price_value}>{nominalPrice}₽</span>
                        </div> <div className={styles.productPriceItem}>
                            <span className={styles.price_name}>Допики</span>
                            <span className={styles.price_separator} />
                            <span className={styles.price_value}>{sumAddition}₽</span>
                        </div>
                    </th>
                    <th style={{ width: 120, padding: 0 }}>
                        <div className={styles.productPriceItem}>
                            <span className={styles.price_name}>₽ за шт.</span>
                            <span className={styles.price_separator} />
                            <span className={styles.price_value}>{additionCoefficient != 0 ? priceSelf.toFixed(2) : priceSelf.toFixed(0)}₽</span>
                        </div><div className={styles.productPriceItem}>
                            <span className={styles.price_name}>Сумма</span>
                            <span className={styles.price_separator} />
                            <span className={styles.price_value}>{priceSumCount}₽</span>
                        </div>
                    </th>
                    <th style={{ width: 100, padding: 0 }}>
                        <div className={styles.productPriceItem}>
                            <span className={styles.price_name}>Вес</span>
                            <span className={styles.price_separator} />
                            <span className={styles.price_value}>{+(+weight / 1000).toFixed(3)}кг</span>
                        </div>
                    </th>
                </tr>
            </tbody>
        </Table>
        {
            errorToast ?
                <ToastContainer
                    style={{
                        position: 'fixed',
                        zIndex: 1,
                        right: 20,
                        bottom: 20
                    }}
                >
                    <Toast
                        className="d-inline-block m-1"
                        bg={errorToast.variant}
                        onClose={() => setErrorToast()}
                    >
                        <Toast.Header>
                            <strong className="me-auto">Внимание!</strong>
                        </Toast.Header>
                        <Toast.Body className={'text-white'}>
                            {errorToast.message}
                        </Toast.Body>
                    </Toast>
                </ToastContainer> : ''
        }

        <Modal show={showQuantityModal} onHide={() => setShowQuantityModal(false)}>
            <Modal.Header closeButton>
                <Modal.Title>Количество: {pendingAddition?.name}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form.Group>
                    <Form.Label>Количество (шт.)</Form.Label>
                    <Form.Control
                        type="number"
                        min={1}
                        step={1}
                        value={quantityInput}
                        onChange={e => setQuantityInput(Math.max(1, parseInt(e.target.value) || 1))}
                    />
                    {pendingAddition && (
                        <Form.Text className="text-muted">
                            Итого: {quantityInput} × {pendingAddition.price}₽ = {quantityInput * pendingAddition.price}₽
                        </Form.Text>
                    )}
                </Form.Group>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => setShowQuantityModal(false)}>Отмена</Button>
                <Button variant="success" onClick={() => {
                    const qty = Math.max(1, parseInt(quantityInput) || 1);
                    const updatedAdditions = currentAdditions.map(addition =>
                        addition.id === pendingAddition.id
                            ? { ...addition, isUse: true, quantity: qty }
                            : addition
                    );
                    setCurrentAddition(updatedAdditions);
                    setSumAddition(sumAddition + qty * pendingAddition.price);
                    setShowQuantityModal(false);
                    setPendingAddition(null);
                }}>Подтвердить</Button>
            </Modal.Footer>
        </Modal>
    </div>
}